export interface Orders {
    orders: Order[];
    summary: Summary;
  }

export enum PaymentProvider {
    CONTRA_ENTREGA = "contra_entrega",
    MERCADO_PAGO = "mercadopago",
    STRIPE = "stripe",
}
  
export interface Order {
    id: number;
    hash_id: string;
    priority: string;
    created_at: string;
    logistic_state: string;
    payment_provider?: PaymentProvider;
    payment_state: string;
    total_value: number;
    total_value_with_discount: number;
    customer_name: string;
    customer_las_name: string;
    customer_prefix_phone: string;
    customer_phone: string;
    customer_email: string;
    customer_address: string;
    total_units: number;
    channel: string;
    dropi_state?: DropiState;
    dropi_url?: string;
    shopify_integration_state?: ShopifyState;
}

export enum DropiState {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}

export enum ShopifyState {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}
  
export interface Summary {
    total_buyers: number;
    total_units: number | string;
    total_value: number | string;
    total_value_with_discount: number | string;
  }